// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.job-chat__placeholder {\n  color: #646d8c;\n}\n", ""]);
// Exports
module.exports = exports;
